var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-widget"},[_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.ld.get(_vm.appdata.response, _vm.options.module, [])}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }